export const CAPI_EVENT_ENDPOINT = "/event";
